import { render, staticRenderFns } from "./RequestTransfer.vue?vue&type=template&id=62ae8131&scoped=true"
import script from "./RequestTransfer.vue?vue&type=script&lang=js"
export * from "./RequestTransfer.vue?vue&type=script&lang=js"
import style0 from "./RequestTransfer.vue?vue&type=style&index=0&id=62ae8131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae8131",
  null
  
)

export default component.exports